import { configureStore } from '@reduxjs/toolkit'

import accountReducer from './slices/account'
import connectionReducer from './slices/connection'
import messagesReducer from './slices/messages'
import requestsReducer from './slices/requests'
import connectionRequestsReducer from './slices/connectionRequests'
import mapFiltersReducer from './slices/mapFilters'
import calendarFiltersReducer from './slices/calendarFilters'

export const store = configureStore({
  reducer: {
    account: accountReducer,
    connection: connectionReducer,
    messages: messagesReducer,
    requests: requestsReducer,
    connectionRequests: connectionRequestsReducer,
    mapFilters: mapFiltersReducer,
    calendarFilters: calendarFiltersReducer,
  },
})

// Get the type of our store variable
export type AppStore = typeof store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch']
